import { RuleTableHandlers, TableConfig } from "../../../../../shared/ui/custom-table/model/table-config.model";

export function createBankAccountTableConfig(
  handlers: RuleTableHandlers = {},
  options: { filterView?: string, defaultFilter?: any } = {}
): TableConfig {
  const {
    onAction = () => { },
    actionMap = {},
    onRowClick = () => { },
    onRowDblClick = () => { },
    onRowExpand = () => { },
    selectable = false,
    summaryTemplate = () => { },
    rowConfig = {},
    headerActions,
    gridActions,
    columns,
  } = handlers;

  const handleAction = (row: any, action: TableRowActionBankAccount) => {
    if (actionMap[action]) {
      actionMap[action](row);
    } else {
      onAction(row, action);
    }
  };

  const hasUid = (row: any) => !!row && !!row.uid;

  return {
    columns: columns,
    actions: [
      { label: 'Editar', icon: 'edit', visible: (row) => hasUid(row), callback: (row) => handleAction(row, TableRowActionBankAccount.Edit) },
      { label: 'Traspaso', icon: 'swap_horiz', visible: (row) => hasUid(row), callback: (row) => handleAction(row, TableRowActionBankAccount.Traspaso) },
      { label: 'Reintegro de efectivo', icon: 'local_atm', visible: (row) => hasUid(row), callback: (row) => handleAction(row, TableRowActionBankAccount.WithdrawCash) },
      { label: 'Ingreso de efectivo', icon: 'account_balance_wallet', visible: (row) => hasUid(row), callback: (row) => handleAction(row, TableRowActionBankAccount.DepositCash) },
      { label: 'Mayor contable', icon: 'list', visible: (row) => !!row && !!row.accountNumber, callback: (row) => handleAction(row, TableRowActionBankAccount.Ledger) },
      { label: 'Importar extracto', icon: 'attach_file', visible: (row) => !!row && !!row.id, callback: (row) => handleAction(row, TableRowActionBankAccount.ImportTransactions) },
      // Nordigen en negociacion: oculto en el front. Para reactivarlo, descomentar.
      // { label: (row: any) => row && row.connected ? 'Gestionar conexión bancaria' : 'Conectar banco', icon: 'link', visible: (row) => !!row && !!row.id, callback: (row) => handleAction(row, TableRowActionBankAccount.ConnectBank) },
      { label: 'Usar en impuestos', icon: 'description', visible: (row) => hasUid(row) && !row.taxationDefault, callback: (row) => handleAction(row, TableRowActionBankAccount.FiscalUse) },
      { label: 'Usar para domiciliación bancaria', icon: 'bookmark', visible: (row) => hasUid(row) && !row.remesa, callback: (row) => handleAction(row, TableRowActionBankAccount.DefaultRemittance) },
    ],
    gridActions: gridActions,
    headerActions: headerActions,
    filterView: options.filterView || 'viewSummaryBankAccountFilters',
    defaultFilter: options.defaultFilter || {},
    rowConfig: {
      ...rowConfig,
      clickable: true,
      onClick: onRowClick,
      onDoubleClick: onRowDblClick,
      onExpand: onRowExpand,
    },
    selectable: selectable,
    pagination: true,
    summaryTemplate: summaryTemplate,
  };
}

export enum TableRowActionBankAccount {
  Edit = 'edit',
  ConnectBank = 'connectBank',
  FiscalUse = 'fiscalUse',
  Traspaso = 'traspaso',
  WithdrawCash = 'withdrawCash',
  DepositCash = 'depositCash',
  Ledger = 'ledger',
  DefaultRemittance = 'defaultRemittance',
  ImportTransactions = 'importTransactions',
}
